import { wait } from "../helpers";

export function useVideoModal() {
  function VideoModal(vm) {
    if (!(vm instanceof Element)) return;

    const videoPlayerUpload = vm.querySelector(".video-modal__upload");
    const videoPlayerVimeo = vm.querySelector(".video-modal__vimeo");
    const vimeoPlayer = videoPlayerVimeo
      ? // eslint-disable-next-line no-undef
        new Vimeo.Player(videoPlayerVimeo)
      : null;
    const videoPlayerYoutube = vm.querySelector(".video-modal__youtube");

    const launchBtns = document.querySelectorAll(".video-modal__launch-btn");
    const closeButton = vm.querySelector(".video-modal__close");

    let videoType = "upload";

    async function launchModal(e) {
      e.preventDefault();
      const lb = e.currentTarget;

      videoType = lb.dataset.videoType;
      const videoUploadId = lb.dataset.videoUploadIds;

      vm.classList.add("active");
      vm.dataset.activePlayer = videoType;

      switch (videoType) {
        case "upload":
          videoPlayerUpload.src = videoUploadId;
          videoPlayerUpload.play();
          break;
        case "vimeo":
          if (
            videoPlayerVimeo.src !==
            `https://player.vimeo.com/video/${videoUploadId}`
          ) {
            videoPlayerVimeo.src = `https://player.vimeo.com/video/${videoUploadId}`;
          }
          await wait(500);
          vimeoPlayer.play();
          break;
        case "youtube":
          if (
            videoPlayerYoutube.src !==
            `https://www.youtube.com/embed/${videoUploadId}`
          ) {
            videoPlayerYoutube.src = `https://www.youtube.com/embed/${videoUploadId}`;
          }
          videoPlayerYoutube.classList.remove("inactive");
          videoPlayerYoutube.setAttribute("tabindex", 0);
          break;
        default:
          break;
      }
    }

    function closeModal() {
      vm.classList.remove("active");

      switch (videoType) {
        case "upload":
          videoPlayerUpload.pause();
          break;
        case "vimeo":
          vimeoPlayer.pause();
          break;
        case "youtube":
          videoPlayerYoutube.classList.add("inactive");
          videoPlayerYoutube.setAttribute("src", "");
          videoPlayerYoutube.setAttribute("tabindex", -1);
          break;
        default:
          break;
      }
    }

    launchBtns.forEach((lb) => {
      lb.addEventListener("click", launchModal);
    });

    closeButton.addEventListener("click", closeModal);
    window.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && vm.classList.contains("active")) closeModal();
    });
  }

  const videoModal = document.querySelector(".video-modal");

  videoModal && VideoModal(videoModal);
}
